import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { AccountInfo, GenericResponse_$reflection, AccountAccess_$reflection, AccountInfo_$reflection } from "./Shared/ApiDataTypes.js";
import { bool_type, obj_type, anonRecord_type, option_type, string_type, union_type, record_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { iterate, toArray, append as append_1, cons, empty, ofArray, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg, some, value as value_82 } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { useState, createElement } from "react";
import React from "react";
import * as react from "react";
import { comparePrimitives, numberHash, uncurry2, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Divider, IconButton, Checkbox, DialogActions, DialogContent, DialogTitle, Dialog, Button, TextField, Typography } from "@mui/material";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { loadingIndicator, SnackError, loadingIndicatorSmall } from "./ViewHelpers.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import Cancel from "@mui/icons-material/Cancel";
import Edit from "@mui/icons-material/Edit";
import Check from "@mui/icons-material/Check";
import Clear from "@mui/icons-material/Clear";
import { useResponsive } from "./Utils.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import Logout from "@mui/icons-material/Logout";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { sortBy, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Components_Chip_51BC9844 } from "./Components/Chip.js";
import { Array_distinctBy } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";
import { Components_LanguageSwitch } from "./Components/LanguageSwitch.js";

class Account extends Record {
    constructor(Info, Accesses) {
        super();
        this.Info = Info;
        this.Accesses = Accesses;
    }
}

function Account_$reflection() {
    return record_type("MyAccount.Account", [], Account, () => [["Info", AccountInfo_$reflection()], ["Accesses", array_type(AccountAccess_$reflection())]]);
}

class PwdError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Current", "New", "NewRepeat"];
    }
}

function PwdError_$reflection() {
    return union_type("MyAccount.PwdError", [], PwdError, () => [[], [], []]);
}

class PwdErrors extends Record {
    constructor(Current, New, NewRepeat) {
        super();
        this.Current = Current;
        this.New = New;
        this.NewRepeat = NewRepeat;
    }
}

function PwdErrors_$reflection() {
    return record_type("MyAccount.PwdErrors", [], PwdErrors, () => [["Current", option_type(string_type)], ["New", option_type(string_type)], ["NewRepeat", option_type(string_type)]]);
}

function PwdErrors_get_empty() {
    return new PwdErrors(undefined, undefined, undefined);
}

class UpdatePwdForm extends Record {
    constructor(Old, New) {
        super();
        this.Old = Old;
        this.New = New;
    }
}

function UpdatePwdForm_$reflection() {
    return record_type("MyAccount.UpdatePwdForm", [], UpdatePwdForm, () => [["Old", string_type], ["New", string_type]]);
}

class PwdValidation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InputMissing", "RepeatMismatch", "Required", "TooShort"];
    }
}

function PwdValidation_$reflection() {
    return union_type("MyAccount.PwdValidation", [], PwdValidation, () => [[], [], [["Item", PwdError_$reflection()]], []]);
}

function testRepeat(str1, str2) {
    if (str1 === str2) {
        return new FSharpResult$2(0, [str1]);
    }
    else {
        return new FSharpResult$2(1, [new PwdValidation(1, [])]);
    }
}

function validatePwd(current, newPwd, newPwdRepeat) {
    let input_3;
    const input = testRepeat(newPwd, newPwdRepeat);
    input_3 = ((input.tag === 1) ? (new FSharpResult$2(1, [singleton(input.fields[0])])) : (new FSharpResult$2(0, [input.fields[0]])));
    if (input_3.tag === 1) {
        return new FSharpResult$2(1, [input_3.fields[0]]);
    }
    else {
        return new FSharpResult$2(0, [new UpdatePwdForm(current, input_3.fields[0])]);
    }
}

function getInputValue(elem) {
    return elem.value;
}

function tryGetInputValue(elem) {
    console.debug("Input elem on get:", elem);
    return [elem.value, elem.validity];
}

function tryGetPwdInput(pwdType, elemOpt) {
    if (elemOpt != null) {
        const elem = elemOpt;
        const value = elem.value;
        const validity = elem.validity;
        console.debug("pwd validity", validity);
        if (validity.valueMissing) {
            return new FSharpResult$2(1, [new PwdValidation(2, [pwdType])]);
        }
        else if (validity.tooShort) {
            return new FSharpResult$2(1, [new PwdValidation(3, [])]);
        }
        else {
            return new FSharpResult$2(0, [value]);
        }
    }
    else {
        return new FSharpResult$2(1, [new PwdValidation(0, [])]);
    }
}

function trySetInputValue(value, elemOpt) {
    if (elemOpt != null) {
        const elem = value_82(elemOpt);
        elem.value = value;
    }
}

function setInputError(elem) {
    elem.setAttribute("error", "");
}

function nameColumn(text) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 20 + "%",
    }], (elems = [MuiHelpers_createElement(Typography, [["children", text]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function valueColumn(children) {
    return createElement("div", {
        style: {
            flexGrow: 1,
            flexShrink: 0,
            flexBasis: 60 + "%",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function editButtonColumn(elem) {
    return createElement("div", {
        style: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: 20 + "%",
        },
        children: elem,
    });
}

function row(children) {
    return createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            padding: 10 + "px",
            columnGap: 10 + "px",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function PasswordUpdate() {
    let elems_1, elems;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState("");
    const current = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const updated = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const patternInput_3 = reactApi.useState(undefined);
    const setErrMsg = patternInput_3[1];
    const errMsg = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const patternInput_5 = reactApi.useState(false);
    const setProcessing = patternInput_5[1];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        width: 100 + "%",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        maxWidth: 350,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elems = toList(delay(() => {
        let props_1;
        return patternInput_4[0] ? append(singleton_1((props_1 = {}, react.createElement(CheckCircle, props_1))), delay(() => singleton_1(MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Account.PwUpdated")]])))) : append(singleton_1(MuiHelpers_createElement(TextField, [["size", "small"], ["type", "password"], ["variant", "outlined"], ["label", ctx.Locale.t("Account.CurrentPw")], ["onChange", (e) => {
            patternInput[1](e.target.value);
        }], ["fullWidth", true], ["style", {
            marginBottom: 15,
        }]])), delay(() => append(singleton_1(MuiHelpers_createElement(TextField, [["size", "small"], ["type", "password"], ["variant", "outlined"], ["label", ctx.Locale.t("Account.NewPw")], ["onChange", (e_1) => {
            patternInput_1[1](e_1.target.value);
        }], ["fullWidth", true], ["style", {
            marginBottom: 15,
        }]])), delay(() => append(singleton_1(MuiHelpers_createElement(TextField, [["size", "small"], ["type", "password"], ["variant", "outlined"], ["label", ctx.Locale.t("Account.RepeatPw")], ["onChange", (e_2) => {
            patternInput_2[1](e_2.target.value);
        }], ["fullWidth", true], ["style", {
            marginBottom: 15,
        }]])), delay(() => append(patternInput_5[0] ? singleton_1(loadingIndicatorSmall()) : singleton_1(MuiHelpers_createElement(Button, [["variant", "contained"], ["fullWidth", true], ["style", {
            backgroundColor: "hsl(207.3, 30.8%, 21%)",
            color: "#FFFFFF",
        }], ["children", ctx.Locale.t("Account.Change")], ["onClick", (_arg_3) => {
            if (current.length === 0) {
                setErrMsg(ctx.Locale.t("Account.CurrentMissing"));
            }
            else if (!(updated.length >= 8)) {
                setErrMsg(ctx.Locale.t("Account.InvalidPw"));
            }
            else if (updated !== patternInput_2[0]) {
                setErrMsg(ctx.Locale.t("Account.PwNotMatching"));
            }
            else {
                setErrMsg(undefined);
                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let item, body, decoder, data_1, caseStrategy_3, extra_3;
                    setProcessing(true);
                    return ((item = {
                        New: updated,
                        Old: current,
                    }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["New", string_type], ["Old", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/password", properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })()))))))).then((_arg_2) => {
                        const res = _arg_2;
                        if (res.tag === 0) {
                            const resp = res.fields[0];
                            if (resp.Result === "success") {
                                patternInput_4[1](true);
                                setProcessing(false);
                                return Promise.resolve();
                            }
                            else {
                                setErrMsg(resp.Message);
                                setProcessing(false);
                                return Promise.resolve();
                            }
                        }
                        else {
                            setProcessing(false);
                            setErrMsg(ctx.Locale.t("Account.PwChangeFailed"));
                            return Promise.resolve();
                        }
                    });
                }));
                pr_1.then();
            }
        }]])), delay(() => singleton_1(createElement("div", {
            style: {
                textAlign: "center",
                maxWidth: 300,
                margin: 10,
                minHeight: 20,
                fontSize: 0.8 + "rem",
            },
            children: (errMsg != null) ? MuiHelpers_createElement(Typography, [["children", errMsg]]) : defaultOf(),
        }))))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function TFAUpdate(tFAUpdateInputProps) {
    let elements_1, elems, elements, props_14;
    const onChange = tFAUpdateInputProps.onChange;
    const info = tFAUpdateInputProps.info;
    const ctx = reactApi.useContext(ctx_1);
    const isAdmin = info.IsAdmin ? true : info.IsSuperAdmin;
    const patternInput = reactApi.useState(false);
    const setUpdatingTfa = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = reactApi.useState("");
    const password = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setProcessing = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setErrMsg = patternInput_4[1];
    const xs_2 = [MuiHelpers_createElement(Dialog, [["open", patternInput[0]], ["fullWidth", true], ["onClose", (_arg_4, v) => {
        setUpdatingTfa(false);
    }], (elements_1 = [MuiHelpers_createElement(DialogTitle, [["children", "Oppdater TFA"]]), MuiHelpers_createElement(DialogContent, [["dividers", true], ["children", createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elems = toList(delay(() => {
        let props_2, props_4;
        return patternInput_1[0] ? append(info.TwoFactor ? singleton_1((props_2 = {}, react.createElement(CheckCircle, props_2))) : singleton_1((props_4 = {}, react.createElement(Cancel, props_4))), delay(() => singleton_1(MuiHelpers_createElement(Typography, [["children", info.TwoFactor ? ctx.Locale.t("Account.TfaActivated") : ctx.Locale.t("Account.TfaDeactivated")]])))) : append(info.ForcedTfa ? singleton_1(MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Account.TfaRequired")]])) : singleton_1(MuiHelpers_createElement(TextField, [["type", "password"], ["fullWidth", true], ["label", ctx.Locale.t("Login.Password")], ["onChange", (e) => {
            patternInput_2[1](e.target.value);
        }], ["helperText", info.TwoFactor ? ctx.Locale.t("Account.EnterPwDeactivate") : ctx.Locale.t("Account.EnterPwActivate")]])), delay(() => {
            const matchValue_1 = patternInput_4[0];
            if (matchValue_1 != null) {
                const errMsg_1 = matchValue_1;
                return singleton_1(createElement("div", {
                    style: {
                        textAlign: "center",
                        margin: 10,
                        minHeight: 20,
                        fontSize: 0.8 + "rem",
                    },
                    children: MuiHelpers_createElement(Typography, [["children", errMsg_1]]),
                }));
            }
            else {
                return singleton_1(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))]]), MuiHelpers_createElement(DialogActions, [(elements = toList(delay(() => (patternInput_3[0] ? singleton_1(loadingIndicatorSmall()) : singleton_1(MuiHelpers_createElement(Button, [["disabled", info.ForcedTfa], ["style", {
        backgroundColor: "hsl(207.3, 30.8%, 21%)",
        color: "#FFFFFF",
    }], ["children", info.ForcedTfa ? ctx.Locale.t("Account.Required") : (info.TwoFactor ? ctx.Locale.t("Account.Deactivate") : ctx.Locale.t("Account.Activate"))], ["onClick", (_arg_5) => {
        if (password.length === 0) {
            setErrMsg(ctx.Locale.t("Account.PleaseEnterPw"));
        }
        else {
            setErrMsg(undefined);
            const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let item, body, decoder, data_1, caseStrategy_3, extra_3;
                if (!info.ForcedTfa) {
                    setProcessing(true);
                    const twoFactorEnabled = !info.TwoFactor;
                    return ((item = {
                        Enabled: twoFactorEnabled,
                        Password: password,
                    }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Enabled", bool_type], ["Password", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/tfa", properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })()))))))).then((_arg_2) => {
                        const res = _arg_2;
                        if (res.tag === 0) {
                            const x_1 = res.fields[0];
                            if (x_1.Result === "success") {
                                patternInput_1[1](true);
                                setProcessing(false);
                                onChange(twoFactorEnabled);
                                return Promise.resolve();
                            }
                            else {
                                setProcessing(false);
                                setErrMsg(x_1.Message);
                                return Promise.resolve();
                            }
                        }
                        else {
                            setErrMsg(ctx.Locale.t("Account.TfaFailed"));
                            return Promise.resolve();
                        }
                    });
                }
                else {
                    return Promise.resolve();
                }
            }));
            pr_1.then();
        }
    }]]))))), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), row([nameColumn(ctx.Locale.t("Account.TwoFactor")), valueColumn([MuiHelpers_createElement(Checkbox, [["size", "small"], ["disabled", true], ["checked", info.TwoFactor]])]), editButtonColumn(!isAdmin ? "Må endres av adminbruker" : MuiHelpers_createElement(IconButton, [["onClick", (_arg_6) => {
        setUpdatingTfa(true);
    }], ["children", (props_14 = {}, react.createElement(Edit, props_14))]]))])];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function NameRow(nameRowInputProps) {
    let elems, props_4, elems_1;
    const onUpdate = nameRowInputProps.onUpdate;
    const account = nameRowInputProps.account;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsUpdated = patternInput_1[1];
    const isUpdated = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const updating = patternInput_2[0];
    const setUpdating = patternInput_2[1];
    const firstNameRef = reactApi.useRef(undefined);
    const lastNameRef = reactApi.useRef(undefined);
    const patternInput_3 = reactApi.useState(undefined);
    return row([nameColumn(ctx.Locale.t("Account.Name")), valueColumn([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        columnGap: 10 + "px",
    }], (elems = toList(delay(() => (!updating ? singleton_1(`${account.FirstName} ${account.LastName}`) : append(singleton_1(MuiHelpers_createElement(TextField, [["inputRef", firstNameRef], ["label", ctx.Locale.t("Account.NewFn")], ["defaultValue", account.FirstName]])), delay(() => singleton_1(MuiHelpers_createElement(TextField, [["inputRef", lastNameRef], ["label", ctx.Locale.t("Account.NewLn")], ["defaultValue", account.LastName]]))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))]), editButtonColumn(!updating ? MuiHelpers_createElement(IconButton, [["onClick", (_arg_2) => {
        setUpdating(true);
    }], ["children", (props_4 = {}, react.createElement(Edit, props_4))]]) : createElement("div", createObj(singleton((elems_1 = toList(delay(() => {
        let props_7, props_9;
        return append(singleton_1(MuiHelpers_createElement(IconButton, [["onClick", (_arg_3) => {
            let input_1, input_3, properties_2;
            let pr_3;
            setProcessing(true);
            let pr_2;
            const item = new AccountInfo(account.Id, account.Email, defaultArg((input_1 = firstNameRef.current, (input_1 == null) ? undefined : getInputValue(input_1)), ""), defaultArg((input_3 = lastNameRef.current, (input_3 == null) ? undefined : getInputValue(input_3)), ""), account.PhoneCC, account.Phone, account.IsAdmin, account.IsSuperAdmin, account.IsPtg, account.TwoFactor, account.ForcedTfa, account.TicketSystem, account.Enabled, account.Company, account.Groups);
            const data = some(Auto_generateBoxedEncoder_437914C6(AccountInfo_$reflection(), undefined, undefined, undefined)(item));
            const decoder = Auto_generateBoxedDecoder_Z6670B51(AccountInfo_$reflection(), undefined, undefined);
            const data_1 = data;
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/edit", properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(AccountInfo_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_2 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_3 = (pr_2.then((res) => {
                setProcessing(false);
                if (res.tag === 0) {
                    setIsUpdated(true);
                    onUpdate(res.fields[0]);
                }
                else {
                    patternInput_3[1](ctx.Locale.t("Account.NameChangeFailed"));
                }
                const pr_1 = new Promise(resolve => setTimeout(resolve, 2000));
                pr_1.then(() => {
                    setUpdating(false);
                    setIsUpdated(false);
                    setProcessing(false);
                });
            }));
            pr_3.then();
        }], ["children", processing ? loadingIndicatorSmall() : (isUpdated ? ((props_7 = {
            color: "success",
        }, react.createElement(CheckCircle, props_7))) : ((props_9 = {}, react.createElement(Check, props_9))))]])), delay(() => {
            let props_12;
            return !isUpdated ? singleton_1(MuiHelpers_createElement(IconButton, [["onClick", (_arg_4) => {
                setUpdating(false);
            }], ["disabled", processing], ["children", (props_12 = {}, react.createElement(Clear, props_12))]])) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])))))]);
}

function PasswordRow() {
    let elems, props_8, elems_1;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const isUpdated = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const updating = patternInput_2[0];
    const setUpdating = patternInput_2[1];
    const currentRef = reactApi.useRef(undefined);
    const pwdRef = reactApi.useRef(undefined);
    const pwdRepeatedRef = reactApi.useRef(undefined);
    const patternInput_3 = useState(PwdErrors_get_empty());
    const setErrors = patternInput_3[1];
    const errors = patternInput_3[0];
    const setErrMsg = reactApi.useState(undefined)[1];
    return row([nameColumn(ctx.Locale.t("Login.Password")), valueColumn([createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px",
    }], (elems = toList(delay(() => (!updating ? singleton_1("**********") : append(singleton_1(MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_1(["onFocus", (_arg_5) => {
        setErrors((current_6) => (new PwdErrors(undefined, current_6.New, current_6.NewRepeat)));
    }]), delay(() => append(singleton_1(["id", "current"]), delay(() => append(singleton_1(["type", "password"]), delay(() => append(singleton_1(["label", ctx.Locale.t("Account.CurrentPw")]), delay(() => append(singleton_1(["required", true]), delay(() => append(singleton_1(["inputProps", {
        autoComplete: "current-password",
    }]), delay(() => append(singleton_1(["inputRef", currentRef]), delay(() => append(singleton_1(["error", errors.Current != null]), delay(() => ((errors.Current != null) ? singleton_1(["helperText", value_82(errors.Current)]) : empty_1()))))))))))))))))))))), delay(() => append(singleton_1(MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_1(["onFocus", (_arg_6) => {
        setErrors((current_7) => (new PwdErrors(current_7.Current, undefined, current_7.NewRepeat)));
    }]), delay(() => append(singleton_1(["id", "new"]), delay(() => append(singleton_1(["type", "password"]), delay(() => append(singleton_1(["label", ctx.Locale.t("Account.NewPw")]), delay(() => append(singleton_1(["required", true]), delay(() => append(singleton_1(["inputProps", {
        minLength: 8,
        autoComplete: "new-password",
    }]), delay(() => append(singleton_1(["inputRef", pwdRef]), delay(() => append(singleton_1(["error", errors.New != null]), delay(() => ((errors.New != null) ? singleton_1(["helperText", value_82(errors.New)]) : empty_1()))))))))))))))))))))), delay(() => singleton_1(MuiHelpers_createElement(TextField, toList(delay(() => append(singleton_1(["onFocus", (_arg_7) => {
        setErrors((current_8) => (new PwdErrors(current_8.Current, current_8.New, undefined)));
    }]), delay(() => append(singleton_1(["id", "new-repeat"]), delay(() => append(singleton_1(["type", "password"]), delay(() => append(singleton_1(["label", ctx.Locale.t("Account.RepeatPw")]), delay(() => append(singleton_1(["inputRef", pwdRepeatedRef]), delay(() => append(singleton_1(["required", true]), delay(() => append(singleton_1(["inputProps", {
        autoComplete: "off",
    }]), delay(() => append(singleton_1(["error", errors.NewRepeat != null]), delay(() => ((errors.NewRepeat != null) ? singleton_1(["helperText", value_82(errors.NewRepeat)]) : empty_1())))))))))))))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))]), editButtonColumn(!updating ? MuiHelpers_createElement(IconButton, [["onClick", (_arg_8) => {
        setUpdating(true);
    }], ["children", (props_8 = {}, react.createElement(Edit, props_8))]]) : createElement("div", createObj(singleton((elems_1 = toList(delay(() => {
        let props_11, props_13;
        return append(singleton_1(MuiHelpers_createElement(IconButton, [["onClick", (_arg_9) => {
            let properties_2;
            let pr_3;
            let validation;
            let input_7;
            let left_2;
            const input = tryGetPwdInput(new PwdError(0, []), currentRef.current);
            left_2 = ((input.tag === 1) ? (new FSharpResult$2(1, [singleton(input.fields[0])])) : (new FSharpResult$2(0, [input.fields[0]])));
            let right_3;
            let left;
            const input_1 = tryGetPwdInput(new PwdError(1, []), pwdRef.current);
            left = ((input_1.tag === 1) ? (new FSharpResult$2(1, [singleton(input_1.fields[0])])) : (new FSharpResult$2(0, [input_1.fields[0]])));
            let right_1;
            const input_2 = tryGetPwdInput(new PwdError(2, []), pwdRepeatedRef.current);
            right_1 = ((input_2.tag === 1) ? (new FSharpResult$2(1, [singleton(input_2.fields[0])])) : (new FSharpResult$2(0, [input_2.fields[0]])));
            const copyOfStruct = left;
            if (copyOfStruct.tag === 1) {
                const copyOfStruct_1 = right_1;
                right_3 = ((copyOfStruct_1.tag === 1) ? (new FSharpResult$2(1, [append_1(copyOfStruct.fields[0], copyOfStruct_1.fields[0])])) : (new FSharpResult$2(1, [copyOfStruct.fields[0]])));
            }
            else {
                const copyOfStruct_2 = right_1;
                right_3 = ((copyOfStruct_2.tag === 1) ? (new FSharpResult$2(1, [copyOfStruct_2.fields[0]])) : (new FSharpResult$2(0, [[copyOfStruct.fields[0], copyOfStruct_2.fields[0]]])));
            }
            const copyOfStruct_3 = left_2;
            if (copyOfStruct_3.tag === 1) {
                const copyOfStruct_1_1 = right_3;
                input_7 = ((copyOfStruct_1_1.tag === 1) ? (new FSharpResult$2(1, [append_1(copyOfStruct_3.fields[0], copyOfStruct_1_1.fields[0])])) : (new FSharpResult$2(1, [copyOfStruct_3.fields[0]])));
            }
            else {
                const copyOfStruct_2_1 = right_3;
                input_7 = ((copyOfStruct_2_1.tag === 1) ? (new FSharpResult$2(1, [copyOfStruct_2_1.fields[0]])) : (new FSharpResult$2(0, [[copyOfStruct_3.fields[0], copyOfStruct_2_1.fields[0]]])));
            }
            if (input_7.tag === 1) {
                validation = (new FSharpResult$2(1, [input_7.fields[0]]));
            }
            else {
                const _arg = input_7.fields[0];
                const input_5 = validatePwd(_arg[0], _arg[1][0], _arg[1][1]);
                validation = ((input_5.tag === 1) ? (new FSharpResult$2(1, [input_5.fields[0]])) : (new FSharpResult$2(0, [input_5.fields[0]])));
            }
            if (validation.tag === 0) {
                setProcessing(true);
                let pr_2;
                const body = Auto_generateBoxedEncoder_437914C6(UpdatePwdForm_$reflection(), undefined, undefined, undefined)(validation.fields[0]);
                const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
                const data_1 = some(body);
                const caseStrategy_3 = undefined;
                const extra_3 = undefined;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/password", properties_3).then((_arg_3) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_3, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_4) => {
                            let matchValue_2;
                            return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_1), _arg_4), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    pr_2 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                }
                catch (exn) {
                    pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
                pr_3 = (pr_2.then((res) => {
                    setProcessing(false);
                    if (res.tag === 0) {
                        if (res.fields[0].Result === "success") {
                            patternInput_1[1](true);
                        }
                    }
                    else {
                        console.error(some("Error updating password:"), res.fields[0]);
                        setErrMsg(ctx.Locale.t("Account.PwChangeFailed"));
                    }
                    const pr_1 = new Promise(resolve => setTimeout(resolve, 2000));
                    pr_1.then(() => {
                        setUpdating(false);
                    });
                }));
            }
            else {
                const errs = validation.fields[0];
                console.error(some("Error validating new passwords"), toArray(errs));
                iterate((_arg_2) => {
                    switch (_arg_2.tag) {
                        case 1: {
                            setErrors((current_1) => (new PwdErrors(current_1.Current, current_1.New, ctx.Locale.t("Account.PwNotMatching"))));
                            break;
                        }
                        case 2: {
                            switch (_arg_2.fields[0].tag) {
                                case 1: {
                                    setErrors((current_3) => (new PwdErrors(current_3.Current, ctx.Locale.t("Account.Required"), current_3.NewRepeat)));
                                    break;
                                }
                                case 2: {
                                    setErrors((current_4) => (new PwdErrors(current_4.Current, current_4.New, ctx.Locale.t("Account.Required"))));
                                    break;
                                }
                                default:
                                    setErrors((current_2) => (new PwdErrors(ctx.Locale.t("Account.Required"), current_2.New, current_2.NewRepeat)));
                            }
                            break;
                        }
                        case 3: {
                            setErrors((current_5) => (new PwdErrors(current_5.Current, ctx.Locale.t("Account.InvalidPw"), current_5.NewRepeat)));
                            break;
                        }
                        default:
                            setErrMsg(ctx.Locale.t("Account.PwChangeFailed"));
                    }
                }, errs);
                pr_3 = (Promise.resolve(undefined));
            }
            pr_3.then();
        }], ["children", processing ? loadingIndicatorSmall() : (isUpdated ? ((props_11 = {
            color: "success",
        }, react.createElement(CheckCircle, props_11))) : ((props_13 = {}, react.createElement(Check, props_13))))]])), delay(() => {
            let props_16;
            return !isUpdated ? singleton_1(MuiHelpers_createElement(IconButton, [["onClick", (_arg_10) => {
                setUpdating(false);
            }], ["disabled", processing], ["children", (props_16 = {}, react.createElement(Clear, props_16))]])) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])))))]);
}

export function View(viewInputProps) {
    let input_1, arg, props_1, elements, elems_8, elems_7;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const responsive = useResponsive(undefined);
    const desktop = (responsive === "desktop") ? true : (responsive === "wideScreen");
    const headerRef = reactApi.useRef(undefined);
    const patternInput = reactApi.useState(undefined);
    const setAccountInfo = patternInput[1];
    const accountInfo = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setError = patternInput_1[1];
    const headerHeight = defaultArg((input_1 = headerRef.current, (input_1 == null) ? undefined : ((arg = input_1, ~~arg.clientHeight))), 0) | 0;
    useEffectOnce(() => {
        let properties_2;
        let pr_5;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(AccountInfo_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/account/me", properties_3).then((_arg_2) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_2, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(AccountInfo_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_3) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_3), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_5 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_5.then((res) => {
            let properties_6;
            if (res.tag === 0) {
                const account = res.fields[0];
                let pr_4;
                let pr_3;
                const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(AccountAccess_$reflection()), undefined, undefined);
                const data_5 = undefined;
                const caseStrategy_10 = undefined;
                const extra_10 = extraCoders;
                try {
                    const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/account/${account.Id}/access`, properties_3_1).then((_arg_4) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_4, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AccountAccess_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_5) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_5), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    pr_3 = (pr_2.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])])))));
                }
                catch (exn_1) {
                    pr_3 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
                pr_4 = (pr_3.then((result_3) => Result_MapError(testRedirect, result_3)));
                pr_4.then((res_1) => {
                    setAccountInfo(new Account(account, (res_1.tag === 1) ? ((setError("Kunne ikke laste tilganger"), [])) : res_1.fields[0]));
                });
            }
            else {
                setError(ctx.Locale.t("Account.InfoFailed"));
            }
        });
    });
    const logOutButton = MuiHelpers_createElement(Button, [["onClick", (_arg_6) => {
        RouterModule_nav(singleton("signout"), 1, 1);
    }], ["color", "primary"], ["variant", "contained"], ["startIcon", (props_1 = {}, react.createElement(Logout, props_1))], (elements = [MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Signout")]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    const xs_8 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_1[0]),
        dismiss: () => {
            setError(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flexBasis: 1000 + "px",
        height: 100 + "%",
    }], (elems_7 = toList(delay(() => {
        let elems_1;
        return append(desktop ? singleton_1(createElement("div", createObj(ofArray([["ref", headerRef], ["style", {
            padding: ((((((0 + "px ") + 0) + "px ") + 10) + "px ") + 10) + "px",
        }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h1"], ["children", "Min side"]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1(), delay(() => {
            let elems_6, elems_5;
            return singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container"])], ["style", {
                height: ("calc(" + (`100vh - 120px - 60px - ${headerHeight}px`)) + ")",
            }], (elems_6 = [createElement("div", createObj(ofArray([["className", join(" ", ["main-tab-container-inner"])], (elems_5 = toList(delay(() => {
                let elems_3, elems_2, props_9;
                if (accountInfo != null) {
                    const info_1 = accountInfo.Info;
                    const accesses_2 = accountInfo.Accesses;
                    return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        rowGap: 5 + "px",
                        padding: 20 + "px",
                        borderRadius: 15 + "px",
                        border: (((1 + "px ") + "solid") + " ") + "var(--grey)",
                    }], (elems_3 = [createElement(NameRow, {
                        account: info_1,
                        onUpdate: (newAccountInfo) => {
                            let input_5;
                            setAccountInfo((input_5 = accountInfo, (input_5 == null) ? undefined : (new Account(newAccountInfo, input_5.Accesses))));
                        },
                    }), MuiHelpers_createElement(Divider, []), row([nameColumn(ctx.Locale.t("Login.Email")), valueColumn([info_1.Email]), editButtonColumn(defaultOf())]), MuiHelpers_createElement(Divider, []), row([nameColumn(ctx.Locale.t("Pages.CustomerGroups")), valueColumn([createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 5 + "px",
                    }], (elems_2 = map_1((access_1) => {
                        const $keyZ3A05D922 = `${access_1.GroupId}-${access_1.CustomerId}`;
                        return createElement(Components_Chip_51BC9844, {
                            key: $keyZ3A05D922,
                            $key: $keyZ3A05D922,
                            primary: access_1.Customer,
                            enabled: true,
                        });
                    }, sortBy((access) => access.GroupId, Array_distinctBy((_arg_8) => _arg_8.CustomerId, accesses_2, {
                        Equals: (x_2, y) => (x_2 === y),
                        GetHashCode: numberHash,
                    }), {
                        Compare: comparePrimitives,
                    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))]), editButtonColumn(MuiHelpers_createElement(IconButton, [["onClick", (_arg_9) => {
                        console.debug("Edit customer groups");
                    }], ["disabled", true], ["children", (props_9 = {}, react.createElement(Edit, props_9))]]))]), MuiHelpers_createElement(Divider, []), createElement(PasswordRow, null), MuiHelpers_createElement(Divider, []), createElement(TFAUpdate, {
                        info: info_1,
                        onChange: (newTfa) => {
                            let input_3, account_1, bind$0040;
                            setAccountInfo((input_3 = accountInfo, (input_3 == null) ? undefined : ((account_1 = input_3, new Account((bind$0040 = account_1.Info, new AccountInfo(bind$0040.Id, bind$0040.Email, bind$0040.FirstName, bind$0040.LastName, bind$0040.PhoneCC, bind$0040.Phone, bind$0040.IsAdmin, bind$0040.IsSuperAdmin, bind$0040.IsPtg, newTfa, bind$0040.ForcedTfa, bind$0040.TicketSystem, bind$0040.Enabled, bind$0040.Company, bind$0040.Groups)), account_1.Accesses)))));
                        },
                    }), MuiHelpers_createElement(Divider, []), row([nameColumn("Språk"), valueColumn([]), editButtonColumn(createElement(Components_LanguageSwitch, null))])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => singleton_1(createElement("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: 10 + "px",
                        },
                        children: reactApi.Children.toArray([logOutButton]),
                    }))));
                }
                else {
                    return singleton_1(loadingIndicator());
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))];
    return react.createElement(react.Fragment, {}, ...xs_8);
}

